module.exports = __webpack_public_path__ + "media/state-press-2_2400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press-2_2400.jpg
// module id = 41
// module chunks = 0